import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 4.2V9m0 0h4.8M15 9l6-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 4.2V9m0 0H4.2M9 9 3 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Shrink";
const Shrink = memo(themed(Icon));
export {
  Shrink
};
//# sourceMappingURL=shrink.js.map
